import { Card } from 'antd';
import styled from 'styled-components';

export const CardStyled = styled(Card)`
    height: 100%;
    .ant-card-body {
        height: 100%;
        padding: 12px;
        display: flex;
        flex-direction: column;
        row-gap: 12px;
    }
`;
